import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {CommissionUpdatePackage} from "../../../../shared/interface/commission-update-package";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute, Router} from "@angular/router";
import {CommissionUpdatePackageService} from "../../../../shared/services/commission-update-package.service";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-commission-update-package-details',
  templateUrl: './commission-update-package-details.component.html',
  styleUrls: ['./commission-update-package-details.component.scss']
})
export class CommissionUpdatePackageDetailsComponent implements OnInit, OnDestroy {
  userPermissions: ReplaySubject<UserPermissions>;
  commissionUpdatePackage: ReplaySubject<CommissionUpdatePackage> = new ReplaySubject<CommissionUpdatePackage>(1);
  commissionUpdatePackageObject: CommissionUpdatePackage = null;
  commissionUpdatePackageId: string;
  selectedTab: number;
  modify = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private commissionUpdatePackageService: CommissionUpdatePackageService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(params => {
        if (params.id === undefined) {
          return;
        }
        this.commissionUpdatePackageId = params.id;
        this.load();
      });
  }

  load(): void {
    this.commissionUpdatePackageService.get(this.commissionUpdatePackageId)
      .subscribe((commissionUpdatePackage: CommissionUpdatePackage) => {
      this.commissionUpdatePackageObject = commissionUpdatePackage;
      this.commissionUpdatePackage.next(commissionUpdatePackage);
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });

      this.router.navigate(['/konfigurator']);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

}
